import { Loading, Message } from 'element-ui'
import axios, { ResponseData } from './axios'

/**
 * 对向量各个分量保留3位小数
 * @author 肖黎望
 * @date 2021-01-17
 * @param {Vector3}
 * @returns {Vector3} 
 */
const parseIntVector3 = function(v){
    var v1 = {
        x: Number(v.x).toFixed(3),
        y: Number(v.y).toFixed(3),
        z: Number(v.z).toFixed(3)
    }
    return v1
}

/**
 * 设置高度重置一个向量
 * @author 肖黎望
 * @date 2021-01-17
 * @param { Vector3 } v
 * @param { Int } height
 * @returns { Vector3 }
 */
const setVector3ViaHeight = function( v, height ){
    let viewer = window.viewer
    if( v.isVector3 ){
        var langlat = viewer.vector3ToLangLat( v )
        langlat.height = height
        return viewer.langLatToVector3( langlat )
    }
}

/**
 * 设置高度重置一个笛卡尔对象
 * @author 肖黎望
 * @date 2021-01-17
 * @param { Cartesian3 } c3
 * @param { Int } height
 * @returns { Cartesian3 }
 */
const setCartesian3ViaHeight = function( c3, height ){
    let viewer = window.viewer
    let langlat = viewer.gisManager.cartesian3ToLangLat( c3 )
    langlat.height = height
    return viewer.gisManager.langLatToCartesian3( langlat )
}

/**
 * 通过两点确定一个HeadingPitch
 * @author 肖黎望
 * @date 2021-01-17
 * @param { Cartesian3 } pointA
 * @param { Cartesian3 } pointB
 * @returns {any}
 */
const setHeadingPitchViaPoint = function( pointA, pointB ){
    //建立以点A为原点，X轴为east,Y轴为north,Z轴朝上的坐标系
    const transform = Cesium.Transforms.eastNorthUpToFixedFrame( pointA )
    //向量AB
    const positionvector = Cesium.Cartesian3.subtract( pointB, pointA, new Cesium.Cartesian3() )
    //因transform是将A为原点的eastNorthUp坐标系中的点转换到世界坐标系的矩阵
    //因此将AB向量转换为A原点坐标系中的向量，需乘以transform的逆矩阵。
    const vector = Cesium.Matrix4.multiplyByPointAsVector( Cesium.Matrix4.inverse(transform, new Cesium.Matrix4()), positionvector, new Cesium.Cartesian3() )
    //归一化
    const direction = Cesium.Cartesian3.normalize(vector, new Cesium.Cartesian3())
    // const heading = Math.atan2(direction.y, direction.x) - Cesium.Math.PI_OVER_TWO
    const heading = Math.atan2(-direction.y, direction.x) + Cesium.Math.PI_OVER_TWO
    const pitch = Cesium.Math.PI_OVER_TWO - Cesium.Math.acosClamped(direction.z)
    return {
        heading,
        pitch
    }
}

var obsClient
const createOBS = function(){
    return new Promise((resolve, reject) => {
        if( obsClient ){
            resolve(obsClient)
            return
        }
        axios.post('api-personal/laozi/v3/common/unauth/getHuaweiParam', {}).then( (res) => {
            obsClient = new ObsClient({
                access_key_id: res.datas.ak,
                secret_access_key: res.datas.sk,
                server: res.datas.endpoint
            })
            resolve(obsClient)
        })
    })
}

const getObsFile = function( bucket, key ){
    return new Promise((resolve, reject) => {
        if( !bucket || !key ){
            resolve('')
            return
        }
        
        createOBS().then(obsClient => {
            let url = '';
            try {
                obsClient.getObject({
                    Bucket: bucket,
                    Key: key,
                    SaveByType : 'file'
                }, function (err, result) {
                    if (err) {
                        console.error('Error-->' + err);
                    }
                    else {
                        if (result.CommonMsg.Status < 300 && result.InterfaceResult) {
                            // 获取下载对象的路径
                            url = result.InterfaceResult.Content.SignedUrl;
                            resolve(url)
                        }
                    }
                })
            } catch (error) {
                
            }
        })
    })
}

const uploadOBS = function( type = 'image', limit = 10 ){
    const Types = {
        image: '.jpg,.jpeg,.png',
        video: '.mp4',
        file: '.pdf'
    }
    var loading
    return new Promise((resolve, reject) => {
        axios.post('api-personal/laozi/v3/common/unauth/getHuaweiParam', {}).then( (res) => {
            const obsUploader = new OBSUploader({
                input_file: "chooseAvatar",
                multiple: true,
                chunked: true,
                ak: res.datas.ak,
                sk: res.datas.sk,
                server: res.datas.endpoint,
                bucket: res.datas.bucket,
                accept: Types[ type ],
                fileLimit: 100,
                fileSingleSizeLimit: 1024 * 1024 * limit,
                onFilesQueued: function(){
                    loading = Loading.service({ fullscreen: true })
                    return true
                },
                onUploadSuccess: function (file, objectKey) {
                    loading.close()
                    const url = 'https://laozi-autopublic-east.obs.cn-east-2.myhuaweicloud.com/' + objectKey
                    resolve({file, objectKey, url})
                },
                onError: function (errorType) {
                    if (errorType == 'Q_TYPE_DENIED') {
                        Message.error(`文件格式不正确，仅支持${ Types[ type ] }文件`)
                    } else if (errorType == 'Q_EXCEED_SIZE_LIMIT') {
                        Message.error(`文件大小超过限制 ( ${limit}MB )`)
                    }
                    loading.close()
                    reject()
                },
                onUploadError: function (file, error) {
                    loading.close()
                    Message.error("上传失败")
                    reject()
                    
                }
            })
            obsUploader.upload(1, '')
        })
    })
}

const getBoundingBox = function( data ){
    var min = { x: Infinity, y: Infinity, z: Infinity },
        max = { x: -Infinity, y: -Infinity, z: -Infinity },
        minX, minY, minZ, maxX, maxY, maxZ
    for (let index = 0; index < data.length; index++) {
        const item = data[index]
        if( item.center && item.radius ){
            minX = item.center.x - item.radius
            minY = item.center.y - item.radius
            minZ = item.center.z - item.radius
            maxX = item.center.x + item.radius
            maxY = item.center.y + item.radius
            maxZ = item.center.z + item.radius
        }
        if( min.x > minX ) min.x = minX
        if( min.y > minY ) min.y = minY
        if( min.z > minZ ) min.z = minX
        if( max.x < maxX ) max.x = maxX
        if( max.y < maxY ) max.y = maxY
        if( max.z < maxZ ) max.z = maxZ
    }
    return { min, max }
}

const createIndicator = function(){
    var mesh = new AMRT.Mesh(
        new AMRT.ConeGeometry( 12, 24, 4 ),
        new AMRT.MeshPhongMaterial({ 
            color: 0x1458EA
        })
    )
    var sphere = new AMRT.Object3D()
    var aa = new AMRT.Object3D()
    let cone_1 = mesh.clone()
    cone_1.rotateX(Math.PI / 4)
    cone_1.translateY(-24)
    aa.add( cone_1 )
    let cone_2 = mesh.clone()
    cone_2.rotateX(-Math.PI / 4)
    cone_2.rotateZ(-Math.PI / 4)
    cone_2.translateY(-24)
    aa.add( cone_2 )
    let cone_3 = mesh.clone()
    cone_3.rotateX(-Math.PI / 4)
    cone_3.rotateZ(Math.PI / 4)
    cone_3.translateY(-24)
    aa.add( cone_3 )
    sphere.onBeforeRender = function(){
        this.rotateY(0.01)
    }
    aa.scale.set(1,-1,1)
    var obj = {t: -1}
    new AMRT.TWEEN.Tween(obj)
    .to({t: 1}, 2000)
    .onUpdate(() => {
        cone_1.position.set( 0, -17, -10 * Math.abs(obj.t) - 17 )
        cone_2.position.set( (-8*Math.abs(obj.t)) - 17, (4.5*Math.abs(obj.t)) - 12, (2.5*Math.abs(obj.t)) + 12 )
        cone_3.position.set( (8*Math.abs(obj.t)) + 17, (4.5*Math.abs(obj.t)) - 12, (2.5*Math.abs(obj.t)) + 12 )
    })
    .repeat( Infinity )
    .start()
    sphere.add( aa )
    sphere.name = 'pointer'
    sphere.type = 'sphere'
    return sphere
}

const findModelByMid = function( mid ){
    let viewer = window.viewer, target = null
    viewer.root.traverse(item => {
        if( item.mid == mid ) target = item
    })
    return target
}

const parseDate = function( date ){
    if( date ){
        date = new Date( date )
        return date.getFullYear() + '-' + ( date.getMonth() + 1 ) + '-' + date.getDate()
    }
}

const rebuildObsPath = function( str ){
    var bucket = '', key = ''
    if( !str ) return { bucket, key }
    if( str.startsWith('laozi') ){
        bucket = str.slice(0, str.indexOf('/'))
        key = str.slice(str.indexOf('/') + 1)
    }else{
        bucket = 'laozi-auto-east'
        key = str
    }
    return{
        bucket,
        key
    }
}

export default {
    parseIntVector3,
    uploadOBS,
    setVector3ViaHeight,
    setCartesian3ViaHeight,
    setHeadingPitchViaPoint,
    getBoundingBox,
    createIndicator,
    findModelByMid,
    parseDate,
    createOBS,
    getObsFile,
    rebuildObsPath
}